var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1620_1408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47375 7.87695C5.62623 7.87723 5.77487 7.92439 5.89917 8.01193C6.02347 8.09947 6.11731 8.22307 6.16775 8.3657C6.21819 8.50833 6.22274 8.66295 6.18078 8.80825C6.13883 8.95356 6.05242 9.08238 5.93349 9.17695V9.9219C5.9266 10.0383 5.87509 10.1478 5.78948 10.2278C5.70387 10.3078 5.59064 10.3524 5.47296 10.3524C5.35528 10.3524 5.24205 10.3078 5.15644 10.2278C5.07083 10.1478 5.01931 10.0383 5.01243 9.9219V9.17565C4.89391 9.08085 4.80794 8.95198 4.76634 8.80677C4.72474 8.66155 4.72957 8.50713 4.78014 8.36475C4.83072 8.22236 4.92457 8.09901 5.04878 8.01165C5.17299 7.9243 5.32145 7.87724 5.47375 7.87695Z",
    fill: "#BABCC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2295 5.25843H2.01055V3.43258C2.01055 2.52221 2.37542 1.64912 3.02489 1.00538C3.67436 0.361646 4.55522 0 5.47371 0C6.3922 0 7.27306 0.361646 7.92253 1.00538C8.572 1.64912 8.93687 2.52221 8.93687 3.43258V5.25843H9.36845V5.25556H10.2632V12.9971H9.77397C9.75529 12.999 9.73687 13 9.71792 13H0.684237V5.25843H1.2295ZM6.83687 1.09238C6.42242 0.855204 5.95228 0.730343 5.47371 0.730343C4.99514 0.730343 4.52501 0.855203 4.11056 1.09237C3.6961 1.32955 3.35194 1.67067 3.11265 2.08146C2.87337 2.49226 2.7474 2.95824 2.74739 3.43258V5.25843H8.20003V3.43258C8.19997 2.95825 8.07398 2.49229 7.8347 2.0815C7.59542 1.67072 7.25128 1.32959 6.83687 1.09238ZM1.42108 12.2697H9.36845V12.2668H9.52634V5.98876H1.42108V12.2697Z",
    fill: "#BABCC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1620_1408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.57895,
    height: 13,
    fill: "white",
    transform: "matrix(-1 0 0 1 10.2632 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d559ed535c3aa8f4779b92ca4d7728a6.svg";
export { ForwardRef as ReactComponent };